import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

// Components
import Page from "../../layout/containers/Page/Page";
import TyreContainer from "../../containers/TyreContainer/TyreContainer";

// Constants
import page from "./page";

const PageWrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
`;

const TyrePage = () => {
  const { ean } = useParams();
  
  return (
    <Page page={page} showBackButton>
      <PageWrapper>
        <TyreContainer ean={ean} />
      </PageWrapper>
    </Page>
  );
};

export default TyrePage;

